<ng-container *ngIf="viewModel$ | async as vm">
  <ng-container *ngIf="formGroup$ | async as fg">
    <label *ngIf="!!vm.input.type && vm.showColumnLabel" [for]="id">{{ vm.input.label }}</label>
    <ng-container *ngIf="vm.input | guardType: isTextInput as txt">
      <input [id]="vm.id" [formControl]="fg.control" type="text" class="form-control" [ngStyle]="{
        width: txt?.size ? txt.size + 'em' : '100%'
      }" autocomplete="off" aria-autocomplete="list" />
    </ng-container>
    <ng-container *ngIf="vm.input | guardType: isDateInput as dte">
      <input [id]="vm.id" [formControl]="fg.control" [type]="dte.time ? 'datetime-local' : 'date'" [min]="dte.min"
        [max]="dte.max" [step]="dte.step" class="form-control" [ngStyle]="{
        width: dte?.size ? dte.size + 'em' : '11em'
      }" autocomplete="off" aria-autocomplete="list" />
    </ng-container>
    <ng-container *ngIf="vm.input | guardType: isNumberInput as num">
      <input [id]="vm.id" [formControl]="fg.control" type="number" [min]="num.min || ''" [max]="num.max || ''"
        [step]="num.step" class="form-control" [ngStyle]="{
        width: num?.size ? num.size + 'em' : '10em'
      }" autocomplete="off" aria-autocomplete="list" />
    </ng-container>
    <ng-container *ngIf="vm.input | guardType: isComboInput as cbo">
      <ng-select [labelForId]="vm.id" [formControl]="fg.control" [ngStyle]="{ width: calcComboWidth(cbo) }"
        [addTag]="cbo.limitToList ? false : cboAddTagFn" addTagText="Other:" [selectOnTab]="true">
        <ng-option *ngFor="let opt of cbo.options" [value]="opt.value" [disabled]="opt.disabled">
          {{ opt.label || opt.value }}
        </ng-option>
      </ng-select>
    </ng-container>
    <ng-container *ngIf="vm.input | guardType: isRadioInput as rdo">
      <div class="form-control border-0" style="height: auto">
        <div *ngFor="let opt of rdo.options; index as o" class="custom-control custom-radio custom-control-inline">
          <input type="radio" [id]="vm.id + 'o' + o" [name]="vm.id" [formControl]="fg.control"
            class="custom-control-input" [value]="opt.value" autocomplete="off"
            [attr.disabled]="opt.disabled ? '' : null" />
          <label class="custom-control-label" [for]="vm.id + 'o' + o">
            <span class="d-inline-block text-truncate" [ngStyle]="{
              width: vm.input.size ? vm.input.size + 'em' : 'auto'
            }">
              {{ opt.label || opt.value }}
            </span>
          </label>
        </div>
        <div *ngIf="rdo.allowOther" class="custom-control custom-radio custom-control-inline">
          <input type="radio" [id]="vm.id + 'oOther'" [name]="vm.id" [formControl]="fg.otherChk"
            class="custom-control-input" [value]="true" autocomplete="off" />
          <label class="custom-control-label" [for]="vm.id + 'oOther'">
            <span class="d-inline-block text-truncate reduce-margin" [ngStyle]="{
              width: vm.input.size ? vm.input.size + 'em' : 'auto'
            }">
              <input type="text" class="form-control" placeholder="Other..." style="width: 100%"
                [formControl]="fg.otherTxt" autocomplete="off" aria-autocomplete="list" />
            </span>
          </label>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="vm.input | guardType: isCheckInput as chk">
      <div class="form-control border-0" style="height: auto">
        <div *ngFor="let opt of chk.options; index as o" class="custom-control custom-checkbox custom-control-inline">
          <input type="checkbox" [id]="vm.id + 'o' + o" class="custom-control-input" [name]="vm.id" [value]="opt.value"
            [checked]="(vm.checked && vm.checked[opt.value]) || false" (change)="cboOnChange($event.target)"
            autocomplete="off" [disabled]="opt.disabled" />
          <label class="custom-control-label" [for]="vm.id + 'o' + o">
            <span class="d-inline-block text-truncate" [ngStyle]="{
              width: vm.input.size ? vm.input.size + 'em' : 'auto'
            }">
              {{ opt.label || opt.value }}
            </span>
          </label>
        </div>
        <div *ngIf="chk.allowOther" class="custom-control custom-checkbox custom-control-inline">
          <input type="checkbox" [id]="vm.id + 'oOther'" [formControl]="fg.otherChk" class="custom-control-input"
            [value]="true" autocomplete="off" />
          <label class="custom-control-label" for="{{ vm.id }}oOther">
            <span class="d-inline-block text-truncate reduce-margin" [ngStyle]="{
              width: vm.input.size ? vm.input.size + 'em' : 'auto'
            }">
              <input type="text" class="form-control" placeholder="Other..." style="width: 100%"
                [formControl]="fg.otherTxt" autocomplete="off" aria-autocomplete="list" />
            </span>
          </label>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>